import React from 'react';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { AppState } from '../../../redux/modules/store';
import { SORRY_MESSAGE_TYPE } from '../../../redux/reducers/SorryMessageReducer';

const Sorry: React.FC = () => {
  console.log('clearing cookies');
  Cookies.remove('sessionId');
  Cookies.remove('userInfo');
  const errorDetail = useSelector((state: AppState) => state.sorryMessage.errorDetail);
  const sorryMessage = useSelector((state: AppState) => state.sorryMessage);

  return (
    <div className='layout-center'>
      <div className='sorry u-text-center'>
        <h1 className='headline-2 u-text-primary'>
          <img className='u-mr8 u-text-middle' src={`${process.env.PUBLIC_URL}/mikomi-icon.svg`} alt='icon' width='36' />
          見込顧客管理
        </h1>

        <h2 className='headline-2 u-mt32' data-testid='sorry-title'>
          {errorDetail?.tilet || sorryMessage.caption || SORRY_MESSAGE_TYPE.SYSTEM_ERROR.caption}
        </h2>

        <p className='u-mt16' data-testid='sorry-explanation'>
          {errorDetail?.message || sorryMessage.explanation || SORRY_MESSAGE_TYPE.SYSTEM_ERROR.explanation}
        </p>
      </div>
    </div>
  );
};

export default Sorry;
